// extracted by mini-css-extract-plugin
module.exports = {"Burger":"Burger_Burger__20L7P"};